<script setup lang="ts">
import type { AddressInput as AddressInputType } from '@precon-tools-suite-by-shared/precon-graphql-types';
import AddressInput from './AddressInput.vue';
import { fieldPropDefs, useFieldProps } from './props';

const props = defineProps(fieldPropDefs);
const emit = defineEmits<{
    (e: 'update:modelValue', value: AddressInputType): void;
}>();

const { id, name, modelValue, fieldProps } = useFieldProps(props, emit, {
    for: (id) => `${id}--address-line-1`,
});
</script>

<template>
    <Field v-bind="fieldProps">
        <AddressInput
            :id="id"
            v-model="modelValue"
            :name="name"
            :strict="props.required"
            :class="props.inputClass"
            :style="props.inputStyle"
            v-bind="$attrs"
        />
        <template #skeleton>
            <Skeleton height="8rem" />
        </template>
    </Field>
</template>
